import { render, staticRenderFns } from "./SectionToc.vue?vue&type=template&id=cae36ed2&scoped=true"
import script from "./SectionToc.vue?vue&type=script&lang=js"
export * from "./SectionToc.vue?vue&type=script&lang=js"
import style0 from "./SectionToc.vue?vue&type=style&index=0&id=cae36ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-load_4e3969014a7d8e6dd81c256359e01f18/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae36ed2",
  null
  
)

export default component.exports